import React, { useState, useEffect } from "react";
import {
  Chip,
  Autocomplete,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  ListItemText,
  MenuItem,
  Radio,
  Select,
  TextField,
  ThemeProvider,
  Tooltip,
  Typography,
  createTheme,
} from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/API_Client";
import CustomButton from "../../reusableComponents/CustomButton";
import SummarizeOutlinedIcon from "@mui/icons-material/SummarizeOutlined";
import ContentHeader from "../../reusableComponents/contentHeader/ContentHeader";
import { customToast } from "../../reusableComponents/customToaster/customToast";
import SmallModal from "../../reusableComponents/modals/SmallModal";
import LoadingLogoPage from "../loadingPage/loadingPage";
import { colorBrandObject } from "../../../constants/brandings";
import { sortArrayValue } from "../utils/utils";

const theme = createTheme({
  components: {
    MuiRadio: {
      styleOverrides: {
        root: {
          color: "#403E9F",
          height: "16px",
          width: "16px",
          marginRight: "8px",
          marginLeft: "10px",
          "&.Mui-checked": {
            color: "#403E9F",
            height: "16px",
            width: "16px",
            marginRight: "8px",
          },
        },
      },
    },
  },
});

export default function GenerateReports() {
  const navigate = useNavigate();
  const { generateReports, getAllModalData, getAllReportType, getPspConfig } =
    useAuth();
  const [generateReportData, setGenerateReportData] = useState([]);
  const [paymentError, setPaymentError] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [pspData, setPspData] = useState([]);
  const [reportTypeData, setReportTypeData] = useState([]);
  const [selectAllColorChange, setSelectAllColorChange] = useState(true);
  const [loading, setLoading] = useState(true);
  const [reportName, setReportName] = useState("");
  const [selectedValue, setSelectedValue] = useState("today");
  const [error, setError] = useState(false);
  const [reportType, setReportType] = useState("AllTransactions");
  const [processorType, setProcessorType] = useState([]);
  const [selectedReportFields, setSelectedReportFields] = useState([]);
  const [updatedProcessors, setUpdatedProcessors] = useState([]);
  const [initialSelectedProcessorType, setInitialSelectedProcessorType] =
    useState([]);
  const [businessUnitsData, setBusinessUnitsData] = useState("");
  const [selectedBusinessUnits, setSelectedBusinessUnits] = useState([]);
  const [allPspData, setAllPspData] = useState([]);

  const handleBusinessUnit = (event, value) => {
    const selectedCodes = value.map((option) => option.code);
    setSelectedBusinessUnits(selectedCodes);
    setProcessorType([])

    let filteredPsp = allPspData.filter(el => selectedCodes.includes(el.businessUnit))
    const uniquePspData = [...new Map(filteredPsp.map((item) => [item.value, item])).values()];
    setPspData(uniquePspData);

  };

  const getBusinessUnitsArr = () => {
    if (selectedBusinessUnits.length > 0) {
      return selectedBusinessUnits;
    }
    let buData = [];
    businessUnitsData.forEach((item) => {
      buData.push(item.code);
    });
    return buData;
  };

  useEffect(() => {
    getAllModalData(
      (data) => {
        const pspData = data?.pspCodes;

        if (!pspData?.length) {
          setLoading(false);
          return;
        }

        getPspConfig(
          (configData) => {
            if (!configData?.length) {
              setLoading(false);
              return;
            }

            const filteredPspData = configData.map((el) => {
              const matchingPsp = pspData.find((psp) => psp.value === el.pspCode);
              return {
                value: el.pspCode,
                title: matchingPsp?.title || '',
                businessUnit: el.legalEntityCode,
              };
            });

            setAllPspData(filteredPspData);
            const uniquePspData = [...new Map(filteredPspData.map((item) => [item.value, item])).values()];
            setPspData(uniquePspData);

            setTimeout(() => setLoading(false), 500);
          },
          (errorMsg) => {

            setPaymentError(errorMsg);
            setLoading(false);
          }
        );
      },
      (errorMsg) => {
        setPaymentError(errorMsg);
        setLoading(false);
      }
    );

    getAllReportType(
      function (data) {
        let filteredReportTypeOptions = [];
        if (data?.length) {
          filteredReportTypeOptions = sortArrayValue(data, "reportTitle");
        }

        setReportTypeData(filteredReportTypeOptions);
      },
      function (errorMsg) { }
    );
  }, []);
  const handleRadioChange = (e) => {
    setSelectedValue(e.target.value);
  };
  const handleChangeReport = (event) => {
    setReportType(event.target.value);
    setSelectedItems([]);
    setSelectAllColorChange(false);
  };
  useEffect(() => {
    const selectedFields = reportTypeData?.find(
      (item) => item.reportType === reportType
    )?.validFields;
    setSelectedReportFields(selectedFields);
  }, [reportType, reportTypeData]);
  useEffect(() => {
    if (pspData && Array.isArray(pspData)) {
      setInitialSelectedProcessorType(pspData.map((option) => option?.value));
    }
  }, [pspData]);


  const handleProcessorChange = (event) => {
    const {
      target: { value },
    } = event;
    setProcessorType(typeof value === "string" ? value.split(",") : value);
  };
  useEffect(() => {
    if (processorType?.length > 0) {
      setUpdatedProcessors(processorType);
    } else {
      setUpdatedProcessors(initialSelectedProcessorType);
    }
  }, [processorType, initialSelectedProcessorType]);
  useEffect(() => {
    const allValues = selectedReportFields?.map((item) => item?.value);
    setSelectedItems(allValues);
  }, [selectedReportFields]);
  const handleCheckboxChange = (item) => {
    if (item === "Select All") {
      if (selectedItems.length === selectedReportFields.length) {
        setSelectedItems([]);
      } else {
        const allValues = selectedReportFields.map((item) => item.value);
        setSelectedItems(allValues);
      }
      setSelectAllColorChange(!selectAllColorChange);
    } else {
      let updatedSelectedItems;

      if (selectedItems.includes(item)) {
        updatedSelectedItems = selectedItems.filter(
          (selected) => selected !== item
        );
      } else {
        updatedSelectedItems = [...selectedItems, item];
      }
      setSelectedItems(updatedSelectedItems);
      const allCheckboxesSelected = selectedReportFields.every((field) =>
        updatedSelectedItems.includes(field.value)
      );
      if (allCheckboxesSelected) {
        setSelectAllColorChange(true);
      } else {
        setSelectAllColorChange(false);
      }
    }
  };

  useEffect(() => {
    let allModalData = localStorage.getItem("allModalData");
    if (allModalData) {
      allModalData = JSON.parse(allModalData);
      if (allModalData?.legalEntities)
        setBusinessUnitsData(allModalData?.legalEntities);
    }
  }, []);

  const today = new Date();
  const [selectedDate, setSelectedDate] = useState(null);
  const [disableButton, setDisableButton] = useState(true);
  const [singleDateError, setSingleDateError] = useState(false);
  const [startDateRangeError, setStartDateRangeError] = useState(false);
  const [endDateRangeError, setEndDateRangeError] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [startDateWithoutField, setStartDateWithoutFiled] = useState(null);
  const [endDateWithoutField, setEndDateWithoutField] = useState(null);
  const [startDateForSingleDate, setStartDateForSingleDate] = useState(null);
  const [endDateForSingleDate, setEndDateForSingleDate] = useState(null);
  const [startDateRange, setStartDateRange] = useState(null);
  const [endDateRange, setEndDateRange] = useState(null);
  const [startDateFormatError, setStartDateFormatError] = useState(false);
  const [endDateFormatError, setEndDateFormatError] = useState(false);
  const [selectedDateFormatError, setSelectedDateFormatError] = useState(false);

  const handleStartDateChange = (date) => {
    setStartDateRangeError(false);
    setStartDate(date);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (isValidDate(date) && date < today) {
      setStartDateFormatError(false);
    } else {
      setStartDateFormatError(true);
    }
  };
  const handleChangeEndDate = (date) => {
    setEndDateRangeError(false);
    setEndDate(date);
    if (isValidDate(date) && date >= startDate) {
      setEndDateFormatError(false);
    } else {
      setEndDateFormatError(true);
    }
  };
  const handleDateChange = (date) => {
    setSingleDateError(false);
    setSelectedDate(date);
    if (isValidDate(date) && date <= today) {
      setSelectedDateFormatError(false);
    } else {
      setSelectedDateFormatError(true);
    }
  };
  const isValidDate = (date) => {
    if (!(date instanceof Date)) return false;

    const currentYear = new Date().getFullYear();

    const year = date.getFullYear();
    if (year < 1990 || year > currentYear) return false;

    const month = date.getMonth() + 1;
    if (month < 1 || month > 12) return false;

    const day = date.getDate();
    if (day < 1 || day > new Date(year, month, 0).getDate()) return false;

    return true;
  };
  const handleSelectedValueChange = (value) => {
    if (value === "yesterday") {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      yesterday.setHours(0, 0, 0, 0);
      const endOfYesterday = new Date();
      endOfYesterday.setDate(endOfYesterday.getDate() - 1);
      endOfYesterday.setHours(23, 59, 59, 999);
      setStartDateWithoutFiled(yesterday);
      setEndDateWithoutField(endOfYesterday);
    } else if (value === "today") {
      const today = new Date();
      today.setDate(today.getDate());
      today.setHours(0, 0, 0, 0);
      const endOfToday = new Date();
      endOfToday.setHours(23, 59, 59, 999);
      setStartDateWithoutFiled(today);
      setEndDateWithoutField(endOfToday);
    } else if (value === "last7Days") {
      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 7);
      startDate.setHours(0, 0, 0, 0);
      const todayEnd = new Date();
      todayEnd.setDate(todayEnd.getDate() - 1);
      todayEnd.setHours(23, 59, 59, 999);
      setStartDateWithoutFiled(startDate);
      setEndDateWithoutField(todayEnd);
    } else if (value === "lastMonth") {
      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 30);
      startDate.setHours(0, 0, 0, 0);
      const todayEnd = new Date();
      todayEnd.setDate(todayEnd.getDate() - 1);
      todayEnd.setHours(23, 59, 59, 999);
      setStartDateWithoutFiled(startDate);
      setEndDateWithoutField(todayEnd);
    } else if (value === "singleDate") {
      if (selectedDate) {
        const startDate = new Date(selectedDate);
        startDate.setHours(0, 0, 0, 0);
        startDate.setDate(startDate.getDate());
        const todayEnd = new Date(selectedDate);
        todayEnd.setHours(23, 59, 59, 999);
        todayEnd.setDate(todayEnd.getDate());
        setStartDateForSingleDate(startDate);
        setEndDateForSingleDate(todayEnd);
      }
    } else if (value === "customizedDates") {
      if (startDate && endDate) {
        const startDateRange = new Date(startDate);
        startDateRange.setHours(0, 0, 0, 0);
        const todayEnd = new Date(endDate);
        todayEnd.setHours(23, 59, 59, 999);
        todayEnd.setDate(todayEnd.getDate());
        setStartDateRange(startDateRange);
        setEndDateRange(todayEnd);
      }
    }
  };
  useEffect(() => {
    handleSelectedValueChange(selectedValue);
  }, [selectedValue, selectedDate, startDate, endDate]);
  const formatDateToUTC = (date) => {
    if (date) {
      let dateIST = new Date(date);
      if (!isNaN(dateIST.getTime())) {
        let dateUTC = dateIST.toISOString();
        return dateUTC;
      }
    }
    return null;
  };
  const utcStartDate = formatDateToUTC(startDateRange);
  const utcEndDate = formatDateToUTC(endDateRange);
  const utcStartDateWithoutFiled = formatDateToUTC(startDateWithoutField);
  const utcEndDateWithoutFiled = formatDateToUTC(endDateWithoutField);
  const utcStartDateForSingleDate = formatDateToUTC(startDateForSingleDate);
  const utcEndDateForSingleDate = formatDateToUTC(endDateForSingleDate);
  const [toggalModal, setToggalModal] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (location.state) {
      setGenerateReportData("");
    }
  }, [location]);

  const handleSubmit = (event) => {
    if (event) {
      event.preventDefault();
    }

    if (reportName.trim() === "") {
      setError(true);
      return;
    } else {
      setError(false);
    }

    let fromDate, toDate;

    if (selectedValue === "singleDate") {
      fromDate = utcStartDateForSingleDate;
      toDate = utcEndDateForSingleDate;
    } else if (selectedValue === "customizedDates") {
      fromDate = utcStartDate;
      toDate = utcEndDate;
    } else {
      fromDate = utcStartDateWithoutFiled;
      toDate = utcEndDateWithoutFiled;
    }

    if (selectedValue === "singleDate") {
      if (selectedDate === null) {
        setSingleDateError(true);
        return;
      } else {
        setSingleDateError(false);
      }
      if (selectedDateFormatError) {
        setSelectedDateFormatError(true);
        return;
      } else {
        setSelectedDateFormatError(false);
      }
    }

    if (selectedValue === "customizedDates") {
      let isValid = true;

      if (startDate === null) {
        setStartDateRangeError(true);
        isValid = false;
      } else {
        setStartDateRangeError(false);
      }

      if (endDate === null) {
        setEndDateRangeError(true);
        isValid = false;
      } else {
        setEndDateRangeError(false);
      }

      if (!isValid) {
        return;
      }
      if (startDateFormatError) {
        setStartDateFormatError(true);
        return;
      } else {
        setStartDateFormatError(false);
      }

      if (endDateFormatError) {
        setEndDateFormatError(true);
        return;
      } else {
        setEndDateFormatError(false);
      }
    }

    let payload = {
      name: reportName,
      fromTimestamp: fromDate,
      toTimestamp: toDate,
      reportType: reportType,
      businessUnits: getBusinessUnitsArr(),
    };

    if (processorType?.length > 0) {
      payload.pspCodes = updatedProcessors;
    }
    generateReports(
      payload,
      function (data) {
        setGenerateReportData(data);
        setLoading(true);
        setTimeout(() => {
          setLoading(false);
          setToggalModal(true);
        }, 800);
      },
      function (errorMsg) {
        setPaymentError(errorMsg);
        customToast("error", "high", errorMsg);
      }
    );
  };

  const handleClose = () => {
    setToggalModal(false);
    navigate("/reports");
  };
  useEffect(() => {
    setSingleDateError(false);
    setStartDateRangeError(false);
    setEndDateRangeError(false);
  }, [selectedValue]);

  useEffect(() => {
    setSelectedDate(null);
    setStartDate(null);
    setEndDate(null);
  }, [selectedValue]);

  useEffect(() => {
    if (
      selectedItems?.length > 0 &&
      reportType?.length > 0 &&
      reportName?.length > 0
    ) {
      setDisableButton(false);
    } else {
      setDisableButton(true);
    }
  }, [reportName, reportType, selectedItems]);

  return (
    <>
      {loading ? (
        <LoadingLogoPage />
      ) : (
        <div className="content-wrapper" style={{ backgroundColor: "white" }}>
          <section className="content">
            <div
              className="reportMainDiv"
              style={{
                border:
                  "1.2px solid var(--border-tertiary, rgba(1, 1, 2, 0.12))",
                padding: "24px 32px",
              }}
            >
              <ContentHeader
                firstHeading="Generate Report"
                secondHeading="Download report for your business. You can now select the specific date and time period for your report"
                icon={<SummarizeOutlinedIcon />}
              />
              <form onSubmit={handleSubmit}>
                <div
                  className="responsive-container"
                  style={{ marginTop: "16px" }}
                >
                  <div className="report-section">
                    <Typography className="font-black-highest bodyB2RegularText">
                      Report Name*
                    </Typography>
                    <TextField
                      variant="outlined"
                      placeholder="Enter Name"
                      id="outlined-basic"
                      sx={{
                        borderRadius: "8px",
                        marginTop: "12px",
                        width: "100%",
                        height: "42px",
                      }}
                      size="small"
                      fullWidth
                      onChange={(e) => {
                        e.target.value = e.target.value.replace(
                          /[^a-zA-Z0-9\s-_()]/g,
                          ""
                        );
                        setReportName(e.target.value);
                        setError(false);
                      }}
                      error={error}
                    />

                    {error && (
                      <div className="errorStyling">
                        <img src="/assets/errorOutline.svg" className="errorImg" />
                        <Typography className="errorMessage">
                          Please enter name
                        </Typography>
                      </div>
                    )}
                  </div>

                  <div className="report-section multiselectInput">
                    <Typography
                      className="font-black-highest bodyB2RegularText"
                      style={{
                        color: "var(--global-neutral-grey-1100, #2D2B32)",
                      }}
                    >
                      Business Unit(s)
                      {/* {userObject?.businessUnits && "*"} */}
                    </Typography>
                    <FormControl style={{ marginTop: "4px", width: "100%" }}>
                      <Autocomplete
                        multiple
                        limitTags={1}
                        options={businessUnitsData}
                        getOptionLabel={(option) => option.name}
                        className="multiselect"
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder={
                              selectedBusinessUnits.length === 0
                                ? "Select Business Unit"
                                : ""
                            }
                          />
                        )}
                        onChange={handleBusinessUnit}
                        renderTags={(value, getTagProps) =>
                          value.map((option, index) => (
                            <Chip
                              key={index}
                              label={option.name}
                              {...getTagProps({ index })}
                              style={{
                                maxWidth: 250,
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            />
                          ))
                        }
                      />
                    </FormControl>
                  </div>
                  <div className="report-section">
                    <Typography className="font-black-highest bodyB2RegularText">
                      Report Type*
                    </Typography>
                    <FormControl style={{ marginTop: "12px", width: "100%" }}>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={reportType}
                        onChange={handleChangeReport}
                        className="menuItemStyle"
                        sx={{
                          width: "100%",
                        }}
                        renderValue={(selected) => (
                          <div className="itemNameStyling">
                            {selected
                              ? reportTypeData?.find(
                                (item) => item.reportType === selected
                              )?.reportTitle
                              : "Select Report Type"}
                          </div>
                        )}
                        displayEmpty
                      >
                        {reportTypeData?.map((item, idx) => (
                          <MenuItem
                            key={idx}
                            value={item?.reportType}
                            className="menuItemStyle"
                          >
                            {item?.reportTitle}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div className="report-section">
                    <Typography className="font-black-highest bodyB2RegularText">
                      Processor
                    </Typography>
                    <FormControl style={{ marginTop: "12px", width: "100%" }}>
                      <Select
                        labelId="demo-multiple-checkbox-label"
                        id="demo-multiple-checkbox"
                        multiple
                        style={{
                          fontFamily: "Poppins",
                          fontSize: "14px",
                          fontWeight: 400,
                          marginRight: "12px",
                          color:
                            "var(--character-title-85, rgba(0, 0, 0, 0.85))",
                        }}
                        value={processorType}
                        onChange={handleProcessorChange}
                        classes={{ icon: "custom-dropdown-icon" }}
                        sx={{
                          width: "100%",
                        }}
                        renderValue={(selected) => (
                          <div className="itemNameStyling">
                            {selected.length > 0
                              ? selected
                                .map(
                                  (value) =>
                                    pspData.find(
                                      (item) => item.value === value
                                    )?.title
                                )
                                .join(", ")
                              : "All Processors"}
                          </div>
                        )}
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: 250,
                            },
                          },
                        }}
                        displayEmpty
                      >
                        {pspData?.map((item) => (
                          <MenuItem
                            key={item?.value}
                            value={item?.value}
                            className="businessUnit businessUnitCheckbox"
                            style={{ padding: "5px 10px", height: "40px" }}
                          >
                            <Checkbox
                              sx={{
                                "& .MuiSvgIcon-root": {
                                  color: colorBrandObject?.secondaryButtonColor,
                                },
                                "&.Mui-checked": {
                                  color: colorBrandObject?.secondaryButtonColor,
                                  "& .MuiSvgIcon-root": {
                                    fill: colorBrandObject?.secondaryButtonColor,
                                  },
                                },
                              }}
                              checked={processorType.indexOf(item?.value) > -1}
                            />
                            <div
                              className="ellipsisListItem"
                              style={{
                                paddingLeft: "6px",
                              }}
                            >
                              {item?.title?.length > 12 ? (
                                <Tooltip title={item?.title}>
                                  <ListItemText primary={item?.title} />
                                </Tooltip>
                              ) : (
                                <ListItemText primary={item?.title} />
                              )}
                            </div>
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </div>
                <div className="marginTopTwenty">
                  <Typography
                    className="bodyB2RegularText font-black-highest"
                    style={{ marginBottom: "12px" }}
                  >
                    Date
                  </Typography>
                  <div className="displayDirectionRow">
                    <ThemeProvider theme={theme}>
                      <div>
                        <div className="radioBtn">
                          <FormControlLabel
                            className={`radioLabels ${selectedValue === "today" && "selectedRadioColor"
                              }`}
                            value="today"
                            control={
                              <Radio
                                sx={{
                                  color:
                                    selectedValue === "today"
                                      ? colorBrandObject?.primaryButtonColor
                                      : colorBrandObject?.primaryButtonColor, // unselected color
                                  "&.Mui-checked": {
                                    color: colorBrandObject?.primaryButtonColor, // selected color
                                  },
                                }}
                              />
                            }
                            label="Today"
                            checked={selectedValue === "today"}
                            onChange={(e) => handleRadioChange(e)}
                          />
                        </div>
                        <div className="radioBtn">
                          <FormControlLabel
                            className={`radioLabels ${selectedValue === "yesterday" &&
                              "selectedRadioColor"
                              }`}
                            value="yesterday"
                            control={
                              <Radio
                                sx={{
                                  color:
                                    selectedValue === "yesterday"
                                      ? colorBrandObject?.primaryButtonColor
                                      : colorBrandObject?.primaryButtonColor, // unselected color
                                  "&.Mui-checked": {
                                    color: colorBrandObject?.primaryButtonColor, // selected color
                                  },
                                }}
                              />
                            }
                            label="Yesterday"
                            checked={selectedValue === "yesterday"}
                            onChange={(e) => handleRadioChange(e)}
                          />
                        </div>

                        <div className="radioBtn">
                          <FormControlLabel
                            className={`radioLabels ${selectedValue === "last7Days" &&
                              "selectedRadioColor"
                              }`}
                            value="last7Days"
                            control={
                              <Radio
                                sx={{
                                  color:
                                    selectedValue === "last7Days"
                                      ? colorBrandObject?.primaryButtonColor
                                      : colorBrandObject?.primaryButtonColor, // unselected color
                                  "&.Mui-checked": {
                                    color: colorBrandObject?.primaryButtonColor, // selected color
                                  },
                                }}
                              />
                            }
                            label="Last 7 days"
                            checked={selectedValue === "last7Days"}
                            onChange={(e) => handleRadioChange(e)}
                          />
                        </div>

                        <div className="radioBtn">
                          <FormControlLabel
                            className={`radioLabels ${selectedValue === "lastMonth" &&
                              "selectedRadioColor"
                              }`}
                            value="lastMonth"
                            control={
                              <Radio
                                sx={{
                                  color:
                                    selectedValue === "lastMonth"
                                      ? colorBrandObject?.primaryButtonColor
                                      : colorBrandObject?.primaryButtonColor, // unselected color
                                  "&.Mui-checked": {
                                    color: colorBrandObject?.primaryButtonColor, // selected color
                                  },
                                }}
                              />
                            }
                            label="Last 30 days"
                            checked={selectedValue === "lastMonth"}
                            onChange={(e) => handleRadioChange(e)}
                          />
                        </div>
                        <div className="radioBtn">
                          <FormControlLabel
                            className={`radioLabels ${selectedValue === "singleDate" &&
                              "selectedRadioColor"
                              }`}
                            value="singleDate"
                            control={
                              <Radio
                                sx={{
                                  color:
                                    selectedValue === "singleDate"
                                      ? colorBrandObject?.primaryButtonColor
                                      : colorBrandObject?.primaryButtonColor, // unselected color
                                  "&.Mui-checked": {
                                    color: colorBrandObject?.primaryButtonColor, // selected color
                                  },
                                }}
                              />
                            }
                            label="Single Date"
                            checked={selectedValue === "singleDate"}
                            onChange={(e) => handleRadioChange(e)}
                          />
                        </div>
                        <div className="radioBtn">
                          <FormControlLabel
                            className={`radioLabels ${selectedValue === "customizedDates" &&
                              "selectedRadioColor"
                              }`}
                            value="customizedDates"
                            control={
                              <Radio
                                sx={{
                                  color:
                                    selectedValue === "customizedDates"
                                      ? colorBrandObject?.primaryButtonColor
                                      : colorBrandObject?.primaryButtonColor, // unselected color
                                  "&.Mui-checked": {
                                    color: colorBrandObject?.primaryButtonColor, // selected color
                                  },
                                }}
                              />
                            }
                            label="Date Range"
                            checked={selectedValue === "customizedDates"}
                            onChange={(e) => handleRadioChange(e)}
                          />
                        </div>
                      </div>
                    </ThemeProvider>
                    <div className="calendarDiv">
                      {selectedValue === "singleDate" ? (
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                              format="dd/MM/yyyy"
                              value={selectedDate}
                              onChange={handleDateChange}
                              maxDate={today}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  style={singleDateError && "errorStyle"}
                                />
                              )}
                            />
                          </LocalizationProvider>
                          {singleDateError && !selectedDateFormatError ? (
                            <div
                              className="errorStyling"
                              style={{ marginLeft: "20px" }}
                            >
                              <img
                                src="/assets/errorOutline.svg"
                                className="errorImg"
                              />
                              <Typography className="errorMessage">
                                Please select date
                              </Typography>
                            </div>
                          ) : null}
                          {selectedDateFormatError && !singleDateError ? (
                            <div
                              className="errorStyling"
                              style={{ marginLeft: "20px" }}
                            >
                              <img
                                src="/assets/errorOutline.svg"
                                className="errorImg"
                              />
                              <Typography className="errorMessage">
                                Please enter a valid date
                              </Typography>
                            </div>
                          ) : null}
                        </div>
                      ) : null}
                      {selectedValue === "customizedDates" ? (
                        <>
                          <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <div style={{ display: "flex" }}>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <DatePicker
                                  format="dd/MM/yyyy"
                                  maxDate={new Date(today.getTime() - 86400000)}
                                  value={startDate}
                                  onChange={handleStartDateChange}
                                  renderInput={(params) => (
                                    <TextField {...params} />
                                  )}
                                />
                                <div className="displayDirectionRow">
                                  {startDateRangeError &&
                                    !startDateFormatError ? (
                                    <div
                                      className="errorStyling"
                                      style={{
                                        marginLeft: "20px",
                                      }}
                                    >
                                      <img
                                        src="/assets/errorOutline.svg"
                                        className="errorImg"
                                      />
                                      <Typography className="errorMessage">
                                        Please select start date
                                      </Typography>
                                    </div>
                                  ) : null}
                                  {startDateFormatError &&
                                    !startDateRangeError ? (
                                    <div
                                      className="errorStyling"
                                      style={{
                                        marginLeft: "20px",
                                      }}
                                    >
                                      <img
                                        src="/assets/errorOutline.svg"
                                        className="errorImg"
                                      />
                                      <Typography className="errorMessage">
                                        Please enter a valid start date
                                      </Typography>
                                    </div>
                                  ) : null}
                                </div>
                              </div>

                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <DatePicker
                                  format="dd/MM/yyyy"
                                  value={endDate}
                                  minDate={startDate || today}
                                  maxDate={today}
                                  disableDates={(date) =>
                                    date < startDate || date > today
                                  }
                                  onChange={handleChangeEndDate}
                                  renderInput={(params) => (
                                    <TextField {...params} />
                                  )}
                                />
                                <div className="displayDirectionRow">
                                  {endDateRangeError && !endDateFormatError ? (
                                    <div
                                      className="errorStyling"
                                      style={{
                                        marginLeft: "21px",
                                      }}
                                    >
                                      <img
                                        src="/assets/errorOutline.svg"
                                        className="errorImg"
                                      />
                                      <Typography className="errorMessage">
                                        Please select end date
                                      </Typography>
                                    </div>
                                  ) : null}

                                  {endDateFormatError && !endDateRangeError ? (
                                    <div
                                      className="errorStyling"
                                      style={{
                                        marginLeft: "21px",
                                      }}
                                    >
                                      <img
                                        src="/assets/errorOutline.svg"
                                        className="errorImg"
                                      />
                                      <Typography className="errorMessage">
                                        Please enter a valid end date
                                      </Typography>
                                    </div>
                                  ) : null}
                                </div>{" "}
                              </div>
                            </div>
                          </LocalizationProvider>
                        </>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div
                  className="marginTopTwenty reportCheckbox"
                  style={{ marginBottom: "12px", display: "none" }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "20px",
                    }}
                  >
                    <Typography className="bodyB2RegularText font-black-highest">
                      Select Fields:
                    </Typography>
                    {selectedReportFields?.length > 0 && (
                      <Grid item xs={12} sm={6} md={3}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginRight: "30px",
                            cursor: "pointer",
                          }}
                          onClick={() => handleCheckboxChange("Select All")}
                        >
                          <Checkbox
                            sx={{
                              "& .MuiSvgIcon-root": {
                                color: colorBrandObject?.secondaryButtonColor,
                              },
                              "&.Mui-checked": {
                                color: colorBrandObject?.secondaryButtonColor,
                                "& .MuiSvgIcon-root": {
                                  fill: colorBrandObject?.secondaryButtonColor,
                                },
                              },
                            }}
                            className="checkbox"
                            checked={
                              selectedItems?.length ===
                              selectedReportFields?.length &&
                              selectedItems?.length > 0
                            }
                          />
                          <Typography
                            className={`bodyB2RegularText font-black-medium ${selectAllColorChange && "selectedFieldStyling"
                              }`}
                          >
                            Select All
                          </Typography>
                        </div>
                      </Grid>
                    )}
                  </div>
                  <Grid container spacing={1}>
                    {selectedReportFields?.map((item, idx) => (
                      <Grid item xs={12} sm={6} md={3} key={idx}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer",
                          }}
                          onClick={() => handleCheckboxChange(item?.value)}
                        >
                          <Checkbox
                            className="checkbox"
                            checked={true}
                            sx={{
                              "& .MuiSvgIcon-root": {
                                color: colorBrandObject?.secondaryButtonColor,
                              },
                              "&.Mui-checked": {
                                color: colorBrandObject?.secondaryButtonColor,
                                "& .MuiSvgIcon-root": {
                                  fill: colorBrandObject?.secondaryButtonColor,
                                },
                              },
                            }}
                          />
                          <Typography
                            className={`bodyB2RegularText font-black-medium ${selectedItems?.includes(item?.value) &&
                              "selectedFieldStyling"
                              }`}
                          >
                            {item.title}
                          </Typography>
                        </div>
                      </Grid>
                    ))}
                  </Grid>
                  {selectedItems?.length === 0 && (
                    <div className="errorStyling" style={{ marginTop: "12px" }}>
                      <img src="/assets/errorOutline.svg" className="errorImg" />
                      <Typography className="errorMessage">
                        Please select atleast one field
                      </Typography>
                    </div>
                  )}
                </div>

                <div className="buttonPosition marginTopTwenty">
                  <CustomButton
                    variant={"outlined"}
                    size={"md"}
                    type={"primary"}
                    text={"Cancel"}
                    onClick={() => navigate("/reports")}
                  />
                  <Button
                    type="submit"
                    className="generateReportBtn"
                    style={{
                      backgroundColor: colorBrandObject?.primaryButtonColor,
                    }}
                  >
                    Generate
                  </Button>
                </div>
              </form>
              <SmallModal
                headerText={"Report generation in progress"}
                subHeaderText={
                  "This may take a few moments. Once completed, you will be able to see that on the dashboard."
                }
                icon={<img src="/assets/infoIconForSmallModal.svg" />}
                toggleDialog={toggalModal}
                filledBtnText={"Got it"}
                filledBtnFunction={handleClose}
              />
            </div>
          </section>
        </div>
      )}
    </>
  );
}
